import { NgModule } from '@angular/core'

import { PhonePipe } from './phone.pipe'
import { FeetAndInchesPipe } from './feet-and-inches.pipe'
import { WordsPipe } from './words.pipe'
import { TruthyPipe } from './truthy.pipe'

@NgModule({
  declarations: [FeetAndInchesPipe, PhonePipe, TruthyPipe, WordsPipe],
  imports: [],
  exports: [FeetAndInchesPipe, PhonePipe, TruthyPipe, WordsPipe],
  providers: [FeetAndInchesPipe, PhonePipe, TruthyPipe, WordsPipe],
})
export class PipesModule {}
